import { Box, Input, InputLabel, Typography, useTheme, useMediaQuery } from '@mui/material';
import React from 'react';
import { IInputFieldProps } from './Types';

const FormInput: React.FC<IInputFieldProps> = ({
  placeholder,
  id,
  type = 'text',
  register,
  error,
  label,
  endAdornment,
  autoComplete = 'off',
  dataTestId,
}) => {
  const isMd = useMediaQuery('(min-width:600px)');
  return (
    <Box sx={{ marginBottom: '16px' }} data-testid={`${dataTestId}-container`}>
      {label && (
        <InputLabel
          sx={{
            fontSize: '18px',
            fontWeight: 500,
            marginBottom: '16px',
            alignSelf: 'flex-start',
            color: '#171717',
          }}
        >
          {label}
        </InputLabel>
      )}
      <Input
        type={type}
        autoComplete={autoComplete}
        placeholder={placeholder}
        id={id}
        sx={{
          border: 0,
          p: '3px',
          pl: '16px',
          width: '100%',
          height: '70px',
          borderRadius: '16px',
          background: '#fff',
          boxShadow: '0 6px 40px rgba(208, 208, 208, 0.4)',
          '&::before': {
            content: 'none',
          },
          '&::after': {
            content: 'none',
          },
          '&::placeholder': {
            color: '#9CA3AF',
            opacity: 1,
          },
          ...(isMd && {
            fontSize: '16px',
          }),
        }}
        inputProps={{
          'data-testid': dataTestId,
          sx: {
            fontSize: '16px',
            color: '#333',
            height: '100%',
            '&::placeholder': {
              opacity: '1',
              color: '#9CA3AF',
            },
          },
        }}
        error={!!error}
        {...register}
        endAdornment={endAdornment}
      />
      {error && (
        <Typography
          sx={{
            fontSize: '15px',
            color: 'red',
            marginTop: '8px',
          }}
          data-testid={`${dataTestId}-error`}
        >
          {error.message as string}
        </Typography>
      )}
    </Box>
  );
};

export default React.memo(FormInput);
